export default __webpack_public_path__ + "static/media/icn-auto-pilot.55ee3518.svg";